import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
export const count = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

count.definition = {
    methods: ["get","head"],
    url: '/app/creator/dashboard/export/count',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
count.url = (options?: RouteQueryOptions) => {
    return count.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
count.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
count.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: count.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
const countForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
countForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardExportCountController::__invoke
* @see app/Http/Controllers/Creator/DashboardExportCountController.php:18
* @route '/app/creator/dashboard/export/count'
*/
countForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: count.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

count.form = countForm

const exportMethod = {
    count: Object.assign(count, count),
}

export default exportMethod